import React from 'react'
import {Link} from 'gatsby'
import moment from 'moment'
import styles from './PostLink.module.scss'

const PostLink = (props) => {
    const {post} = props
    return (
        <div className={styles.postLinkBox}>
            <Link to={post.path} key={post.title}>
                <div>
                    <h2>{post.title}</h2>
                    <span className={styles.date}>{moment(post.date).format('YYYY-MM-DD')}</span>
                    <p>{post.description}</p>
                </div>
            </Link>       
        </div>
    )
}

export default PostLink
